import React, { useEffect, useRef } from "react"

import { FlashPlayer } from "@shared/components"
import { createFlashVodPlayer } from "@shared/modules"
import { playerService } from "@shared/services"

import {
  useSelectedVod,
  useSetVodPlayer,
  useVodPlayer,
  VodType,
} from "vod/contexts"

export default function FlashVodPlayer() {
  const vod = useSelectedVod()
  const vodPlayer = useVodPlayer()
  const setVodPlayer = useSetVodPlayer()
  const playerWrapRef = useRef<HTMLDivElement>(null)
  const playerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!playerRef || vodPlayer || !vod) return
    const vodFlag = getVodFlagByVodType(vod.vodType)
    const fileName = vod.fileName
    ;(async () => {
      setVodPlayer(
        await createFlashVodPlayer(
          playerRef.current!,
          {
            domain: vod.vodHost,
            vodPath: vod.middlePath,
            vodFlag: vodFlag,
            filename: fileName,
          },
          () => {
            playerService.handleFullMode(playerWrapRef)
          },
        ),
      )
    })()
  }, [playerRef, vodPlayer, setVodPlayer, vod])

  useEffect(() => {
    if (!vod || !vodPlayer) return

    const vodFlag = getVodFlagByVodType(vod.vodType)
    const fileName = vod.fileName

    vodPlayer.setStreamUrl!(vodFlag, fileName)
  }, [vodPlayer, vod])

  return (
    <article className="vodB" ref={playerWrapRef}>
      <FlashPlayer playerRef={playerRef} />
    </article>
  )
}

const getVodFlagByVodType = (vodType: VodType): VodFlag => {
  switch (vodType) {
    case "LONG": {
      return "LVOD"
    }
    case "STOCK": {
      return "CVOD"
    }
    case "NORMAL":
    default: {
      return "SVOD"
    }
  }
}

type VodFlag = "SVOD" | "LVOD" | "CVOD"
